import React, { useState, useEffect } from "react";
import DropdownTreeSelect from "react-dropdown-tree-select";
import "react-dropdown-tree-select/dist/styles.css";


function Dropdown(props) {

  const treeData = props.data || [];
  const {nodeToggle,placeholder="Select Division"} = props; 


  // const [treeData, setTreeData] = useState([
  //   {
  //     label: "Select All",
  //     value: "toggleSelectAll",
  //     _toggleSelectAll: true,
  //     checked: true,
  //   },
  // ]);

  const [isSelectAll, setIsSelectAll] = useState(true);

  // useEffect(() => {
  //   const data = props.data || [];
  //   setTreeData([
  //     {
  //       label: "Select All",
  //       value: "toggleSelectAll",
  //       _toggleSelectAll: true,
  //       checked: true,
  //     },
  //     ...data,
  //   ]);
  // }, [props.data]);

  // const updateCheckedStatus = (nodes, checked) => {
  //   return nodes.map((node) => ({
  //     ...node,
  //     checked,
  //     children: node.children ? updateCheckedStatus(node.children, checked) : node.children,
  //   }));
  // };

  const updateCheckedStatus = (nodes, checked) => {
    return nodes.map((node) => ({
      ...node,
      checked,  // Update the checked status of all nodes
      children: node.children ? updateCheckedStatus(node.children, checked) : node.children,
    }));
  };

  const onChange = (currentNode) => {

      

    // if (currentNode._toggleSelectAll) {
    //   // Toggle all nodes
    //   const updatedData = updateCheckedStatus(treeData.slice(1), !isSelectAll);  // Toggle status for all child nodes
    //   setTreeData([
    //     {
    //       ...treeData[0],
    //       checked: !isSelectAll,  // Toggle the 'Select All' checkbox
    //     },
    //     ...updatedData,  // Update child nodes with the same status
    //   ]);
    //   setIsSelectAll(!isSelectAll);  
    //   props.onChange("selectAll", updatedData); 
    // } else {
    //   let currentNodeLabel = currentNode.path >= 0 ? "parent" : "child";  // Identify parent or child node
    //   props.onChange(currentNodeLabel, currentNode);  // Pass to parent onChange handler
    // }
  };

  

  return (
    <DropdownTreeSelect
      data={treeData}
      onChange={props.onChange}
      texts={{ placeholder: placeholder }}
      className="mdl-demo"
      keepTreeOnSearch={true}
      keepChildrenOnSearch={true}
      showPartiallySelected={true}
      onNodeToggle={e => nodeToggle(e)}
    />
  );
}

export default Dropdown;